import React, { useEffect, useState } from 'react';
import { Modal, Button, Input } from 'antd';
import { FormItemLabel, ModalTitle } from '../../../components/text/Titles';
import { Dataset } from '../../../types/dataset';

type Props = {
  title: string;
  visible: boolean;
  onClose: () => any;
  onSave: (name: string) => any;
  dataset: Dataset;
};

export const RenameDataset = (props: Props) => {
  const { title, visible, onClose, onSave, dataset } = props;

  const [name, setName] = useState<string>('');

  useEffect(() => {
    if (!name && dataset && visible) {
      setName(dataset.name);
    }
  }, [dataset, name, visible]);

  const onSubmit = async () => {
    onClose();
    onSave(name);
    setName('');
  };

  const onCancel = async () => {
    onClose();
    setName('');
  };

  if (!dataset) return null;

  return (
    <Modal
      maskClosable={false}
      visible={visible}
      title={<ModalTitle>{title}</ModalTitle>}
      onCancel={onCancel}
      footer={
        <div>
          <Button type="default" onClick={onCancel}>
            Cancel
          </Button>
          <Button style={{ marginLeft: '10px' }} type="primary" onClick={onSubmit} disabled={name === ''}>
            Rename
          </Button>
        </div>
      }>
      <FormItemLabel>This process will rename the dataset.</FormItemLabel>
      <Input
        placeholder="Dataset name"
        value={name}
        onChange={e => setName(e.target.value)}
        style={{ margin: '10px 0px 10px 0px' }}
      />
    </Modal>
  );
};
